import type { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { WORK_ORDER_UI } from '~/app/components/maintenance/work-orders/work-order-ui-colors';
import { CurativeIncidentActions } from '@evimo/components/maintenance/work-orders/WorkOrderKanbanPageContainer/components/CurativeIncidentActions/CurativeIncidentActions';
import {
  isCurativeTicketType,
  shortPlanCode,
} from '@evimo/components/maintenance/work-orders/WorkOrderKanbanPageContainer/utils';

export type TicketCurativeContextProps = {
  type: string;
  planName: string | null;
  planCode: string | null;
  ticketId?: string;
  ticketTitle?: string | null;
  organizationId?: string;
  incidentId: string | null;
  incidentCode: string | null;
  incidentTitle: string | null;
  summaryMaxRows?: number;
  onBeforeNavigate?: () => void;
};

export const TicketCurativeContext: FC<TicketCurativeContextProps> = ({
  type,
  planName,
  planCode,
  ticketTitle = null,
  incidentId,
  incidentCode,
  incidentTitle,
  summaryMaxRows,
  onBeforeNavigate,
}) => {
  const { t } = useTranslation('maintenance');

  if (isCurativeTicketType(type)) {
    return (
      <CurativeIncidentActions
        ticketType={type}
        ticketTitle={ticketTitle ?? ''}
        incidentId={incidentId}
        incidentCode={incidentCode}
        incidentTitle={incidentTitle}
        summaryMaxRows={summaryMaxRows}
        onBeforeNavigate={onBeforeNavigate}
      />
    );
  }

  return (
    <>
      {planName ? (
        <Typography.Text
          strong
          style={{
            display: 'block',
            marginTop: 6,
            fontSize: 12,
            color: WORK_ORDER_UI.sidebarNavy,
          }}
        >
          {t('workOrders.kanban.planNameLabel', { name: planName })}
        </Typography.Text>
      ) : null}
      {planCode ? (
        <Typography.Text
          type="secondary"
          title={planCode}
          style={{ display: 'block', marginTop: 2, fontSize: 11 }}
        >
          {t('workOrders.kanban.planCodeLabel', {
            code: shortPlanCode(planCode),
          })}
        </Typography.Text>
      ) : null}
    </>
  );
};
